import type { CardholderOnboardingTranslations } from "../interfaces/cardholderOnboarding";

export const cardholderOnboardingTranslations: CardholderOnboardingTranslations = {
  page_title: "Cadastro de titulares",
  page_subtitle:
    "Leve cada titular de uma organização do cadastro até poder ter cartão. Cada linha diz onde ele está e o que fazer.",
  action_refresh: "Atualizar",
  retry: "Tentar de novo",
  cancel: "Cancelar",
  close: "Fechar",
  unnamed: "Sem nome",
  provider_unknown: "o emissor de cartões",
  error_generic: "Não conseguimos concluir a ação. Tente de novo em um instante.",

  scope_label: "Organização",
  scope_placeholder: "Busque por nome, e-mail ou ID",
  scope_loading: "Carregando organizações…",
  scope_empty: "Nenhuma organização corresponde",
  scope_searching: "Buscando…",
  scope_search_error: "Não conseguimos buscar organizações",
  scope_catalog_error: "Não conseguimos carregar as organizações",
  scope_catalog_truncated: "Só as mais recentes aparecem; digite para buscar as demais",
  scope_required_hint: "Escolha a organização cujos titulares você quer revisar",
  scope_org_hint: "Titulares desta organização",
  summary_line: "{{name}} · emite com {{provider}} · {{count}} titulares",

  pick_org_title: "Escolha uma organização",
  pick_org_description: "Você verá cada um dos titulares, em que etapa está e o que falta para ter cartão.",
  load_error: "Não conseguimos carregar os titulares desta organização.",
  denied_error: "Seu usuário não tem permissão para ver os titulares.",
  unsupported_notice:
    "Esta organização emite com {{provider}}: os titulares são cadastrados ao serem criados, então aqui só se tentam de novo os cadastros que falharam.",
  truncated_notice: "A organização tem mais de 2.000 titulares; só os mais recentes aparecem.",

  bucket_ready: "Prontos para enviar",
  bucket_paused: "Em pausa",
  bucket_needs_verification: "Sem verificação",
  bucket_needs_data: "Faltam dados",
  bucket_registration_failed: "Cadastro falhou",
  bucket_in_progress: "Em andamento",
  bucket_enabled: "Habilitados",
  bucket_closed: "Encerrados",

  search_placeholder: "Busque por nome, documento ou e-mail",
  clear_filters: "Ver todos",
  empty_organization: "Esta organização ainda não tem titulares",
  empty_bucket: "Não há titulares neste grupo",
  empty_search: "Nenhum titular corresponde a “{{term}}”",

  column_holder: "Titular",
  column_progress: "Andamento",
  column_next: "Próximo passo",
  own_identity_badge: "A organização",
  select_page: "Selecionar os desta página",
  select_row: "Selecionar {{name}}",
  bulk_selected: "Selecionados: {{count}}",
  bulk_clear: "Limpar seleção",
  bulk_send: "Enviar para {{provider}}",

  track_label: "Andamento do titular",
  step_registration: "Cadastro",
  step_verification: "Verificação",
  state_done: "concluído",
  state_current: "em andamento",
  state_blocked: "parado",
  state_failed: "falhou",
  state_pending: "pendente",

  headline_ready: "Verificado e pronto para enviar para {{provider}}.",
  headline_ready_resume: "Verificado; ficou pela metade em {{provider}} e pode ser retomado.",
  headline_paused: "Em pausa em {{provider}}.",
  headline_paused_reason: "Em pausa em {{provider}}: {{reason}}.",
  headline_verification_missing: "Não tem uma verificação de identidade vinculada.",
  headline_verification_not_approved: "A verificação dele não consta como aprovada.",
  headline_verification_other_service:
    "A verificação foi feita com outro serviço de identidade; não dá para enviar daqui.",
  headline_verification_incomplete: "O registro de verificação está incompleto; revise com o time técnico.",
  headline_missing_email: "A organização não tem um e-mail desta pessoa.",
  headline_missing_identity_fields: "Falta o sobrenome ou a data de nascimento.",
  headline_registration_failed: "O cadastro como titular não terminou.",
  headline_in_progress: "{{provider}} está processando.",
  headline_in_review: "{{provider}} está revisando os documentos.",
  headline_enabled: "Habilitado: já pode ter cartões.",
  headline_identity_rejected: "A identidade foi rejeitada.",
  headline_card_rejected: "{{provider}} rejeitou o cadastro.",
  headline_business: "É uma empresa: {{provider}} só dá cartões a pessoas.",
  headline_closed: "Não há nada a fazer com este titular.",

  action_send: "Enviar",
  action_resume: "Retomar",
  action_link_verification: "Vincular verificação",
  action_sync_verification: "Revisar verificação",
  action_complete_data: "Ver o que falta",
  action_retry_registration: "Tentar cadastro de novo",

  skip_already_enabled: "Já está habilitado",
  skip_already_rejected: "O cadastro foi rejeitado",
  skip_no_kyc_record: "Não tem verificação de identidade",
  skip_kyc_not_verified: "A verificação não está aprovada",
  skip_no_kyc_applicant: "A verificação não está vinculada",
  skip_missing_identity_fields: "Falta o sobrenome ou a data de nascimento",
  skip_missing_client_email: "A organização não tem o e-mail dele",
  skip_limit_reached: "Ficou de fora pelo limite deste envio",
  skip_concurrent_conflict: "Outro envio o pegou ao mesmo tempo",
  skip_error: "Não foi possível colocar na fila",
  skip_changed: "O status mudou; atualize o painel",

  kyc_PENDING: "pendente",
  kyc_IN_REVIEW: "em revisão",
  kyc_VERIFIED: "aprovada",
  kyc_REJECTED: "rejeitada",
  kyc_EXPIRED: "vencida",
  no_kyc: "Sem verificação",

  send_title: "Enviar para {{provider}}",
  send_description: "Primeiro conferimos quem pode ser enviado; nada sai até você confirmar.",
  send_checking: "Conferindo quem pode ser enviado…",
  send_ready: "Prontos para enviar: {{count}}.",
  send_queue_note:
    "São cadastrados em {{provider}} um a um, na mesma fila dos cartões novos, então o status muda em alguns minutos.",
  send_none: "Nenhum pode ser enviado ainda.",
  send_paused_note: "Estavam em pausa: {{count}}. Se o motivo não foi corrigido, vão pausar de novo.",
  send_skipped_heading: "Não são enviados ({{count}}):",
  send_confirm: "Enviar ({{count}})",
  send_recheck: "Conferir de novo",
  send_done_heading: "Enviados",
  send_done_counts: "Pela primeira vez: {{queued}}. Retomados: {{resumed}}.",
  send_done_skipped: "Ficaram de fora ao enviar: {{count}}. Confira-os de novo no painel.",
  send_done_note: "Atualize o painel em alguns minutos para ver o andamento em {{provider}}.",

  link_title: "Vincular verificação",
  link_description: "Busca a verificação de identidade de {{name}} e a vincula ao cadastro.",
  link_searching: "Buscando a verificação…",
  link_found: "Encontramos uma verificação desta pessoa.",
  link_match_by: "Corresponde por {{field}}",
  match_external_user_id: "o cadastro na Coloca",
  match_document_number: "número do documento",
  match_birthdate_name: "nome e data de nascimento",
  match_email: "e-mail",
  match_manual: "vínculo manual",
  link_confirm: "Vincular",
  link_done: "Verificação vinculada.",
  link_done_verified: "Verificação vinculada e aprovada. Você já pode enviá-lo para {{provider}}.",
  link_other_identity: "Essa verificação é de outra pessoa cadastrada na Coloca; aqui não é vinculada.",
  link_linked_elsewhere:
    "A verificação acabou vinculada a outra pessoa cadastrada na Coloca, não a esta. Revise com compliance.",
  link_category_linked: "Verificação vinculada.",
  link_category_linkable: "A verificação pode ser vinculada.",
  link_category_superseded: "Há outra verificação aprovada mais recente desta pessoa.",
  link_category_match_unverified:
    "Há uma verificação com o mesmo e-mail, mas nem o documento nem a data de nascimento coincidem; não é vinculada sozinha.",
  link_category_ambiguous: "A verificação corresponde a mais de uma pessoa; revise com compliance.",
  link_category_foreign_external_id: "A verificação está em nome de outra identidade.",
  link_category_already_linked: "Já tem uma verificação vinculada; confira o status.",
  link_category_other_provider: "A verificação foi feita com outro serviço de identidade.",
  link_category_no_applicant: "Não encontramos uma verificação feita pela Coloca para esta pessoa.",
  link_category_orphan: "A verificação não corresponde a ninguém cadastrado na Coloca.",
  link_category_applicant_not_found: "Não existe uma verificação com esse ID.",
  link_category_error: "Não conseguimos consultar a verificação.",
  link_manual_label: "Você tem o ID da verificação?",
  link_manual_placeholder: "ID da verificação",
  link_manual_search: "Buscar",
  link_manual_hint:
    "Para verificações feitas fora da Coloca. Só é vinculada se o documento, ou o nome e a data de nascimento, coincidirem.",
  link_manual_invalid: "Confira o ID: só letras, números, hífens e sublinhados, de 6 a 64 caracteres.",
  link_org_identity_hint:
    "É a identidade da própria organização. Se a verificação foi feita fora da Coloca, vincule-a em Verificação de contas.",
  link_org_identity_open: "Ir para Verificação de contas",

  sync_title: "Revisar verificação",
  sync_description: "Compara o status da verificação de {{name}} com o que temos salvo.",
  sync_checking: "Comparando com a verificação…",
  sync_mismatch: "A verificação consta como {{remote}}, mas aqui está {{local}}.",
  sync_in_sync: "Aqui e na verificação consta {{status}}; não há nada a atualizar.",
  sync_not_reviewed: "A verificação ainda não foi revisada.",
  sync_no_reference: "Não tem uma verificação vinculada.",
  sync_applicant_not_found:
    "A verificação vinculada não existe mais e não há outra aprovada para usar; revise com o time técnico.",
  sync_other_provider: "A verificação foi feita com outro serviço de identidade.",
  sync_green_sibling: "Esta pessoa tem outra verificação aprovada; você pode usá-la no lugar da atual.",
  sync_apply: "Mudar para {{status}}",
  sync_repoint: "Usar a verificação aprovada",
  sync_recheck: "Conferir de novo",
  sync_updated: "Status atualizado: {{status}}.",
  sync_repointed: "Agora usa a verificação aprovada.",

  data_title: "O que falta",
  data_missing_identity_fields:
    "Falta o sobrenome ou a data de nascimento de {{name}}, e sem isso não dá para cadastrar. Complete na ficha de cliente e envie de novo.",
  data_missing_email:
    "A organização não tem um e-mail de {{name}}. Adicione na ficha de cliente e envie de novo.",
  data_ok: "Entendi",

  retry_title: "Tentar cadastro de novo",
  retry_description:
    "Cadastra {{name}} de novo com os dados já salvos. Se der certo, segue para a verificação e depois para {{provider}}.",
  retry_done: "Cadastro concluído: {{name}}.",

  detail_verification: "Verificação",
  detail_card: "Em {{provider}}",
  detail_email: "E-mail de contato",
  detail_country: "País",
  detail_updated: "Última mudança no emissor",
  detail_created: "Criado",
  detail_identity_id: "ID da identidade",
};
